// src/views/student-words-list/openedLists.ts
// Plakietka „nowa” na kartach list ucznia. Nowa jest lista udostępniona w ostatnich 7 dniach, której uczeń jeszcze
// nie otworzył. Otwarte listy pamięta przeglądarka, osobno dla każdego konta — na innym urządzeniu ta sama lista
// znów jest nowa, najwyżej do końca tych 7 dni. Czyta je i zapisuje tylko ten plik
const STORAGE_KEY_PREFIX = 'openedLists:';
const NEW_FOR_MS = 7 * 24 * 60 * 60 * 1000;

const storageKey = (studentId: number) => `${STORAGE_KEY_PREFIX}${studentId}`;

const readOpenedListIds = (studentId: number): number[] => {
  try {
    const ids = JSON.parse(localStorage.getItem(storageKey(studentId)) || '[]');

    return Array.isArray(ids) ? ids : [];
  } catch {
    return [];
  }
};

const markListOpened = (studentId: number, listId: number) => {
  const ids = readOpenedListIds(studentId);

  if (ids.includes(listId)) {
    return;
  }

  try {
    localStorage.setItem(storageKey(studentId), JSON.stringify([...ids, listId]));
  } catch { /* pamięć przeglądarki pełna albo zablokowana — lista zostaje „nowa” do końca 7 dni */ }
};

// Datę udostępnienia uczniowi przysyła serwer w shareMetadata — po niej ekran też sortuje. Bez daty lista nie jest nowa
const isNewList = (list: any, openedIds: number[]): boolean => {
  const sharedAt = Date.parse(list.shareMetadata?.sharedAt);

  return Number.isFinite(sharedAt) && Date.now() - sharedAt < NEW_FOR_MS && !openedIds.includes(list.id);
};

export {
  readOpenedListIds,
  markListOpened,
  isNewList,
};
